import React from 'react'
import { Slider } from '@fluentui/react'
import { INumberValue } from 'model/FlexibleAttributeModel';
import _ from 'lodash';

interface IProps {
    [key: string]: any;
    fieldValueOnChange?: (event: any, value: INumberValue) => void;
    defaultFieldValue?: INumberValue;
    max?: number;
}

const SliderPercentControl: React.FunctionComponent<IProps> = (props) => {
    const { label, max, disabled, handleChange, defaultValue } = props;

    const sliderAriaValueText = (value: number) => `${value} percent`;
    const sliderValueFormat = (value: number) => `${value}%`;

    const fieldValueOnChange = _.debounce(
        (value: number, range?: [number, number], event?: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            const t: INumberValue = {
                type: 'number',
                value: value!
            }
            props.fieldValueOnChange?.(event, t);
        }, 410);

    return (
        <Slider
            label={label}
            max={max ?? 100}
            ariaValueText={sliderAriaValueText}
            valueFormat={sliderValueFormat}
            showValue
            disabled={disabled}
            defaultValue={props.defaultFieldValue ? props.defaultFieldValue.value : defaultValue}
            onChange={props.fieldValueOnChange ? fieldValueOnChange : handleChange}
        />
    );
}

export default SliderPercentControl